import { render, staticRenderFns } from "./PositionTable.vue?vue&type=template&id=755265fa&scoped=true"
import script from "./PositionTable.vue?vue&type=script&lang=js"
export * from "./PositionTable.vue?vue&type=script&lang=js"
import style0 from "./PositionTable.vue?vue&type=style&index=0&id=755265fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755265fa",
  null
  
)

export default component.exports